import EventDispatcher from "../../utils/manager/manager/eventdispatcher/EventDispatcher";

class CustomNotificationManager extends EventDispatcher
{

};

const CUSTOMNOTIFICATIONMANAGER = new CustomNotificationManager();
export default CUSTOMNOTIFICATIONMANAGER;